import React, { useEffect, useRef } from 'react';
import { Box, Input, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';

import { useStores } from '../../hooks/use-stores';
import { loc } from '../../lib/loc';
import { ProfileLoc } from '../../loc/profile';

import PreloadButton from '../../interface/PreloadButton';
import CityAutocomplete from '../Registration/CityAutocomplete';

const EditCompanyData = observer(() => {
    const {
        ProfileDataStore: store,
        RegisterStore: { cities, getCities, setSelectedCity, selectedCity },
    } = useStores();
    const { editCompanyData, editLoader } = store || {};
    const { company: { title, address, inn, cityId } = {} } = store.profile || {};

    const innRef = useRef();
    const companyRef = useRef();
    const addrRef = useRef();

    const handle = e => {
        e.preventDefault();
        editCompanyData(companyRef.current.value, innRef.current.value, selectedCity.title, addrRef.current.value);
    };

    useEffect(() => {
        getCities();
    }, [getCities]);

    useEffect(() => {
        setSelectedCity(cities.filter(item => item.id === cityId)[0]);
    }, [cities, cityId, setSelectedCity]);

    return (
        <form onSubmit={handle}>
            <Box display="flex" flexDirection="column">
                <Box mb={2}>
                    <Typography variant="h6">{loc(ProfileLoc.changeCompanyData)}</Typography>
                </Box>
                <Input
                    inputRef={companyRef}
                    className="login-form__input"
                    placeholder={loc(ProfileLoc.newCompany)}
                    defaultValue={title}
                    type="text"
                    required
                />
                <Input
                    inputRef={innRef}
                    className="login-form__input"
                    placeholder={loc(ProfileLoc.newTIN)}
                    defaultValue={inn}
                    type="text"
                    required
                />

                <CityAutocomplete />

                <Input
                    inputRef={addrRef}
                    className="login-form__input"
                    placeholder={loc(ProfileLoc.newAddress)}
                    defaultValue={address}
                    type="text"
                    required
                />
                <Box>
                    <PreloadButton isLoad={editLoader}>{loc(ProfileLoc.sendButton)}</PreloadButton>
                </Box>
            </Box>
        </form>
    );
});

export default EditCompanyData;
